export const FEATURE_FLAG_TOGGLE = 'FEATURE_FLAG_TOGGLE';
export const FEATURE_FLAGS_LOAD = 'FEATURE_FLAGS_LOAD';
export const FEATURE_FLAGS_LOAD_SUCCESS = 'FEATURE_FLAGS_LOAD_SUCCESS';
export const FEATURE_FLAGS_LOAD_FAILURE = 'FEATURE_FLAGS_LOAD_FAILURE';
